<script setup lang="ts">
import { CoreEventSource } from '@apps/main/new-desktop/core/models';
import {
  useBrowserStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import {
  isPeekPriceModalHotelOnlyItinerary,
  isPeekPriceModalPlaceholderItinerary,
} from '../../models';
import { usePeekPriceStore } from '../../stores';

import PeekPriceModalDesktop from './PeekPriceModalDesktop.vue';
import PeekPriceModalMobile from './PeekPriceModalMobile.vue';

interface PeekPriceModalEmits {
  (eventName: 'cancel'): void;
  (eventName: 'confirm'): void;
}

const emit = defineEmits<PeekPriceModalEmits>();

const browserStore = useBrowserStore();
const peekPriceStore = usePeekPriceStore();
const statsigEventsStore = useStatsigEventsStore();

function onSelectDate(date: Date): void {
  statsigEventsStore.logHotelSelectionPeekPriceModalDateSelected();
  statsigEventsStore.logCoreDateChanged({
    source: CoreEventSource.HotelSelection,
  });
  peekPriceStore.preselectDate(date);
}

function onSelectMonth(date: Date): void {
  statsigEventsStore.logHotelSelectionPeekPriceModalMonthSelected();
  peekPriceStore.selectMonth(date);
}
</script>

<template>
  <template v-if="peekPriceStore.itinerary">
    <PeekPriceModalMobile
      v-if="
        browserStore.isSmallerThan600px ||
        isPeekPriceModalPlaceholderItinerary(peekPriceStore.itinerary)
      "
      :hotel-name="peekPriceStore.itinerary.hotelName"
      :calendar="peekPriceStore.calendar"
      @cancel="emit('cancel')"
      @confirm="emit('confirm')"
      @select-date="onSelectDate"
      @select-month="onSelectMonth"
    />
    <PeekPriceModalDesktop
      v-if="
        browserStore.isLargerThan599px &&
        isPeekPriceModalHotelOnlyItinerary(peekPriceStore.itinerary)
      "
      :itinerary="peekPriceStore.itinerary"
      :calendar="peekPriceStore.calendar"
      @cancel="emit('cancel')"
      @confirm="emit('confirm')"
      @select-date="onSelectDate"
      @select-month="onSelectMonth"
    />
  </template>
</template>
